// extracted by mini-css-extract-plugin
export var connectionButton = "_c2-1";
export var connectionButtonFloating = "_c2-2";
export var connectionContainer = "_c2-0";
export var rightPanel = "_c2-6";
export var stepCard = "_c2-3";
export var stepCardSubtitle = "_c2-5";
export var stepCardText = "_c2-4";